import type { UpdateStates } from 'bundles/account-settings/constants/SettingsConstants';

export const NotificationPreferenceChannels = {
  EMAIL: 'email',
  PUSH: 'push',
} as const;

export type NotificationPreferenceChannel =
  (typeof NotificationPreferenceChannels)[keyof typeof NotificationPreferenceChannels];

type GlobalNotificationPreferenceCategory = 'promotions' | 'recommendations' | 'volunteer' | 'degrees';

export type GlobalChannelNotificationPreferences = Record<
  GlobalNotificationPreferenceCategory,
  Record<NotificationPreferenceChannel, boolean>
>;

export type CourseEmailPreference = {
  id: string;
  value: {
    announcements: boolean;
    reminders: boolean;
    discussionForums: boolean;
  };
  name: string;
  logo: string;
  description: string;
};

export type GlobalNotificationPreferences = {
  promotions: boolean;
  recommendations: boolean;
  volunteer: boolean;
  degrees: boolean;
};

export type CourseraNormalizedEmailPreference = {
  id: string;
  value: { promotions: boolean } | { recommendations: boolean } | { volunteer: boolean } | { degrees: boolean };
  name: string;
};

export type PartnerEmailPreference = {
  id: string;
  value: {
    subscriptions: boolean;
  };
  name: string;
};

export type EmailPreference = CourseraNormalizedEmailPreference | PartnerEmailPreference | CourseEmailPreference;

export type UpdateStatus = {
  state: (typeof UpdateStates)[keyof typeof UpdateStates];
};
